// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserData } from "./AppRoutes";

interface ProtectedRouteProps {
  isAuthenticated: UserData | null;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthenticated,
  children,
}) => {
  const location = useLocation();

  const storedData = localStorage.getItem("odessa_user_details");

  const userData = storedData ? JSON.parse(storedData) : null;

  const token = isAuthenticated
    ? isAuthenticated?.accessToken
    : userData?.accessToken;

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
